import { computed } from 'vue'
import { freezeObject } from '@/global/utils/utils'
import TabActionButtonsWithTitle from '@/global/components/view-layouts/tabs-layout/components/TabActionButtons.vue'
import ItemExecutionDetailsInfo from '../components/ItemExecutionDetailsInfo.vue'

const TAB_KEY = 'item_execution_details'
const TRANSLATION_NAMESPACE = 'road-maintenance/temporary_regulation/item_execution'

function createItemExecutionDataFetched (translate) {
  return function itemExecutionDataFetched (event) {
    const { data: apiData, updateData } = event || {}
    const data = apiData?.data || {}

    const activeActivityLocation = data?.active_activity?.location
    const activeActivityLocationLabel = activeActivityLocation?.name || activeActivityLocation?.address || null

    updateData({
      status_label: data?.status?.description ? translate(data.status.description) : (data?.status?.name || null),
      vehicle_registration: data?.vehicle?.registration || null,
      active_location_label: data?.active_location?.name || data?.active_location?.address || null,
      vehicle_label: data?.vehicle?.label || null,
      active_activity_label: data?.active_activity?.name
        ? `${data.active_activity.name}${activeActivityLocationLabel ? ` - ${activeActivityLocationLabel}` : ''}`
        : null
    })
  }
}

export function useItemExecutionDetails (options) {
  const { translate, resolveRouteParamValue } = options || {}

  const apiConfig = freezeObject({
    get: {
      module: 'road-maintenance',
      route: `work-orders/exec-routes/${resolveRouteParamValue('id')}`
    }
  })

  const tabActions = computed(() => ({
    component: TabActionButtonsWithTitle,
    title: translate(`${TRANSLATION_NAMESPACE}.item_execution_details`),
    showEditButtons: false,
    showBackButton: {
      uiViewName: 'TemporaryRegulationsItemExecution'
    },
    visible: true
  }))

  const infoBlock = computed(() => ({
    component: ItemExecutionDetailsInfo,
    visible: true
  }))

  return computed(() => ({
    key: TAB_KEY,
    apiConfig,
    dataFetched: createItemExecutionDataFetched(translate),
    tabContent: [
      tabActions.value,
      infoBlock.value
    ]
  }))
}
